import axios from "axios";
import { API_BASE_URL } from "config/runtime";
const $API = axios.create({
    baseURL: API_BASE_URL,

    headers: {
        "Content-type": "application/json",
    }

});
$API.interceptors.request.use(async (config) => {
    const token = localStorage.getItem('token');
    config.headers!.Authorization = `Bearer ${token}`;;

    return config;
});

$API.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('userRole')
            window.location.href = "/auth";
        }
        return Promise.reject(error);
    }
);
export default $API;

